(function () {
  const LOC_US = 111335735680;
  const LOC_INTL = 126957;

  function getQtyForLoc(invJson, locId) {
    const list = invJson?.invLoc;
    if (!Array.isArray(list)) return null;
    const row = list.find(x => Number(x?.loc?.id) === Number(locId));
    return typeof row?.qty === "number" ? row.qty : null;
  }

  function isAvailableForMarket(invLocByVariant, variantId, isUsaMarket) {
    const invJson = invLocByVariant[String(variantId)];
    const locId = isUsaMarket ? LOC_US : LOC_INTL;
    const qty = getQtyForLoc(invJson, locId);
    if (qty === null) return null; // no location data -> fall back to Shopify's own flag
    return qty > 0;
  }

  function ensureBadge(wrapper) {
    let badge = wrapper.querySelector('[id^="Badge-"], [id^="NoMediaStandardBadge-"]');
    if (badge) return badge;

    const container = wrapper.querySelector('.card__badge');
    if (!container) return null;

    badge = document.createElement('span');
    badge.setAttribute('data-market-badge', 'true');
    badge.className = 'badge badge--bottom-left';
    container.appendChild(badge);
    return badge;
  }

  function applyBadge(wrapper, available) {
    const badge = ensureBadge(wrapper);
    if (!badge) return;

    if (!available) {
      badge.textContent = wrapper.dataset.soldOutLabel || 'Sold out';
      badge.style.display = '';
    } else if (badge.dataset.marketBadge === 'true') {
      // only remove badges we injected — never touch a server-rendered "on sale" badge
      badge.style.display = 'none';
    }
  }

  function applyButtonState(wrapper, available) {
    const button = wrapper.querySelector('button[id$="-submit"][name="add"]');
    if (!button) return;

    const label = button.querySelector('span:not(.sold-out-message)');
    const soldOutMsg = button.querySelector('.sold-out-message');

    if (available) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }

    if (label) {
      label.textContent = available
        ? (wrapper.dataset.addToCartLabel || 'Add to cart')
        : (wrapper.dataset.soldOutLabel || 'Sold out');
    }
  }

  function updateCard(wrapper) {
    const productId = wrapper.dataset.productId;
    const sectionId = wrapper.dataset.sectionId;
    const isUsaMarket = wrapper.dataset.isUsaMarket === 'true';

    const invLocEl = document.getElementById(`InvLocData-${sectionId}-${productId}`);
    if (!invLocEl) return;

    let invLocByVariant;
    try {
      invLocByVariant = JSON.parse(invLocEl.textContent || '{}');
    } catch (e) {
      console.log('[OU] card inv-loc parse failed', productId, e);
      return;
    }

    const hiddenInput = wrapper.querySelector('.product-variant-id');

    // Single-variant "add to cart" card
    if (hiddenInput) {
      const variantId = hiddenInput.value;
      const serverDisabled = hiddenInput.hasAttribute('disabled');
      const marketAvail = isAvailableForMarket(invLocByVariant, variantId, isUsaMarket);
      const available = marketAvail === null ? !serverDisabled : marketAvail;

      wrapper.classList.toggle('card-soldout', !available);
      applyBadge(wrapper, available);
      applyButtonState(wrapper, available);
      return;
    }

    // Multi-variant "choose options" card — badge only.
    // Treat as available if ANY variant is available for this market.
    const variantIds = Object.keys(invLocByVariant);
    if (!variantIds.length) return;

    let anyAvailable = false;
    let anyDataFound = false;

    variantIds.forEach(id => {
      const marketAvail = isAvailableForMarket(invLocByVariant, id, isUsaMarket);
      if (marketAvail !== null) anyDataFound = true;
      if (marketAvail === true) anyAvailable = true;
    });

    if (!anyDataFound) return; // no location metafield data at all — leave server-rendered badge alone

    wrapper.classList.toggle('card-soldout', !anyAvailable);
    applyBadge(wrapper, anyAvailable);
  }

  function init() {
    document.querySelectorAll('.card-market-availability').forEach(updateCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after filter/sort/infinite-scroll re-renders a section
  document.addEventListener('shopify:section:load', init);
})();